export const NAV_SECTIONS = [
  {
    id: "home",
    label: "Inicio",
    order: 0,
    items: [
      {
        id: "home",
        label: "Inicio",
        requiresBranch: false,
        path: "/home",
      },
    ],
  },
  {
    id: "pos",
    label: "Punto de venta",
    order: 10,
    items: [
      {
        id: "pos",
        label: "POS",
        permissions: ["sales.create", "pos.sell"],
        requiresBranch: true,
        path: ({ branchId }) =>
          branchId ? `/branches/${branchId}/purchases/new` : null,
      },
    ],
  },
  {
    id: "sales",
    label: "Ventas y documentos",
    order: 20,
    items: [
      {
        id: "sales-list",
        label: "Ventas",
        permissions: ["sales.read"],
        requiresBranch: true,
        path: ({ branchId }) =>
          branchId ? `/branches/${branchId}/purchases` : null,
      },
      {
        id: "quotations-list",
        label: "Cotizaciones",
        permissions: ["quotation.read", "quotation.create"],
        requiresBranch: true,
        path: ({ branchId }) =>
          branchId ? `/branches/${branchId}/quotations` : null,
      },
      {
        id: "purchase-orders-list",
        label: "Ordenes de compra",
        permissions: ["purchase_order.read"],
        requiresBranch: true,
        path: ({ branchId }) =>
          branchId ? `/branches/${branchId}/purchase-orders` : null,
      },
      {
        id: "delivery-guides",
        label: "Guias",
        permissions: [
          "delivery_guide.read",
          "delivery_guide.create",
          "delivery_guide.bulk",
          "delivery_guide.transfer",
        ],
        requiresBranch: true,
        path: ({ branchId }) =>
          branchId ? `/branches/${branchId}/delivery-guides` : null,
      },
    ],
  },
  {
    id: "clients",
    label: "Clientes",
    order: 30,
    items: [
      {
        id: "clients-list",
        label: "Clientes",
        permissions: ["client.read"],
        requiresBranch: false,
        path: "/client",
      },
    ],
  },
  {
    id: "catalog",
    label: "Lista de precios",
    order: 50,
    items: [
      {
        id: "price-list",
        label: "Lista de precios",
        permissions: ["product.read"],
        requiresBranch: true,
        path: ({ branchId }) =>
          branchId ? `/branches/${branchId}/price-list` : null,
      },
    ],
  },
  {
    id: "purchases",
    label: "Compras",
    order: 60,
    items: [
      {
        id: "stock-list",
        label: "Compras",
        permissions: ["stock.read"],
        requiresBranch: true,
        path: ({ branchId }) =>
          branchId ? `/branches/${branchId}/stock` : null,
      },
      {
        id: "inventory",
        label: "Inventario",
        permissions: ["stock.read"],
        requiresBranch: true,
        path: ({ branchId }) =>
          branchId ? `/branches/${branchId}/inventory` : null,
      },
      {
        id: "stock-requests",
        label: "Solicitudes a matriz",
        permissions: ["stock.read"],
        requiresBranch: true,
        path: ({ branchId }) =>
          branchId ? `/branches/${branchId}/stock-requests` : null,
      },
      {
        id: "providers-list",
        label: "Proveedores",
        permissions: ["provider.read"],
        requiresBranch: true,
        path: ({ branchId }) =>
          branchId ? `/branches/${branchId}/providers` : null,
      },
    ],
  },
  {
    id: "reports",
    label: "Reportes",
    order: 100,
    items: [
      {
        id: "reports-home",
        label: "Resumen",
        permissions: ["stock.read", "branch_expense.read", "client.read"],
        requiresBranch: true,
        path: ({ branchId }) =>
          branchId ? `/branches/${branchId}/reports` : null,
      },
      {
        id: "reports-sales",
        label: "Ventas",
        permissions: ["sales.read", "branch_expense.read"],
        requireAll: true,
        requiresBranch: true,
        path: ({ branchId }) =>
          branchId ? `/branches/${branchId}/reports/sales` : null,
      },
      {
        id: "reports-finance",
        label: "Finanzas",
        permissions: ["sales.read", "stock.read", "branch_expense.read", "client.read"],
        requireAll: true,
        requiresBranch: true,
        path: ({ branchId }) =>
          branchId ? `/branches/${branchId}/reports/finances` : null,
      },
      {
        id: "reports-receivables",
        label: "Cobranza",
        permissions: ["client.read"],
        requiresBranch: true,
        path: ({ branchId }) =>
          branchId ? `/branches/${branchId}/reports/receivables` : null,
      },
      {
        id: "reports-expenses",
        label: "Gastos",
        permissions: ["branch_expense.read"],
        requiresBranch: true,
        path: ({ branchId }) =>
          branchId ? `/branches/${branchId}/expenses` : null,
      },
      {
        id: "reports-cash-logs",
        label: "Historial de cajas",
        permissions: ["cash_register.logs.read"],
        requiresBranch: true,
        path: ({ branchId }) =>
          branchId ? `/branches/${branchId}/cash-register-logs` : null,
      },
    ],
  },
];
